/**
 * View reducer, relatively simple since it's just an overwrite
 * @param  {object} acc     routing state
 * @param  {object} payload action payload
 * @return {object}         new routing state
 */
export default function view(acc, payload) {
  return { ...acc, view: payload };
}



// WEBPACK FOOTER //
// ./app/middleware/router/view.js